import { custom, deserialize, serializable } from 'serializr';
import { JiraFieldAllowedValue } from './jira-field-allowed-value.model';
import { Deserializable } from '@models/deserializable';

export class JiraIssueField implements Deserializable {
  @serializable
  public id: string;
  @serializable
  public name: string;
  @serializable
  public required: boolean;
  @serializable
  public hasDefaultValue: boolean;
  @serializable
  public autoCompleteUrl: URL;
  @serializable(
    custom(
      (v) => v,
      (v) => v,
    ),
  )
  public schema: Map<string, string>;
  @serializable
  public key: string;
  @serializable(
    custom(
      (v) => v,
      (v) => {
        const returnValue: JiraFieldAllowedValue[] = [];
        (v || []).forEach((value) =>
          returnValue.push(new JiraFieldAllowedValue().deserialize(value)),
        );
        return returnValue;
      },
    ),
  )
  public allowedValues: JiraFieldAllowedValue[];

  deserialize(input: any): this {
    return Object.assign(this, deserialize(JiraIssueField, input));
  }

  get isSystemField(): boolean {
    return !!this.schema['system'];
  }

  get isSummaryField(): boolean {
    return this.key == 'summary';
  }

  get isDescriptionField(): boolean {
    return this.key == 'description';
  }

  get isPriorityField(): boolean {
    return this.key == 'priority';
  }

  get isDueDateField(): boolean {
    return this.key == 'duedate';
  }

  get isCustomField(): boolean {
    return this.key.includes('customfield_');
  }

  get isCustomTextField(): boolean {
    return this.schema['custom'] && this.schema['custom'].includes('text');
  }

  get isCustomTextAreaField(): boolean {
    return this.schema['custom'] && this.schema['custom'].includes('textarea');
  }

  get isCustomSelect(): boolean {
    return this.schema['custom'] && this.schema['custom'].includes('select');
  }

  get isCustomMultiSelect(): boolean {
    return (
      this.schema['custom'] && this.schema['custom'].includes('multiselect')
    );
  }

  get isCustomRadio(): boolean {
    return (
      this.schema['custom'] && this.schema['custom'].includes('radiobuttons')
    );
  }

  get isCustomMultiCheckbox(): boolean {
    return (
      this.schema['custom'] && this.schema['custom'].includes('multicheckboxes')
    );
  }

  get isCustomNumberField(): boolean {
    return this.schema['custom'] && this.schema['custom'].includes('float');
  }

  get isCustomURLField(): boolean {
    return this.schema['custom'] && this.schema['custom'].includes('url');
  }

  get canShowOnTSForm(): boolean {
    return (
      this.isSummaryField ||
      this.isDescriptionField ||
      this.isPriorityField ||
      this.isDueDateField ||
      (this.isCustomField &&
        (this.isCustomURLField ||
          this.isCustomNumberField ||
          this.isCustomTextField ||
          this.isCustomTextAreaField ||
          this.allowedValues?.length > 0))
    );
  }

  get type(): string {
    if (this.isDescriptionField || this.isCustomTextAreaField)
      return 'textarea';
    else if (this.isSummaryField || this.isCustomTextField) return 'text';
    else if (this.isCustomNumberField) return 'number';
    else if (this.isCustomURLField) return 'url';
    else if (this.isPriorityField) return 'priority';
    else if (
      this.isCustomSelect ||
      this.isCustomMultiSelect ||
      this.isPriorityField
    )
      return 'dropdown';
    else if (this.isCustomMultiCheckbox) return 'multicheckbox';
    else if (this.isCustomRadio) return 'radio';
    else if (this.isDueDateField) return 'date';
  }
}
